import type { MenuTreeTypes, MenuTypes } from "@/types/MenuTypes";
import { getCmmnUserMenuRoutes } from "@/api/login/LoginApi";
import { userSidebarStore } from "@/app/store/SidebarStore";

/**
 * 사용자 사이드바(메뉴) 초기화 및 설정
 *
 * @remarks
 * - 사용자 구분에따른 API를 호출하여 사용자 메뉴를 조회하고,
 *   변환 후 메뉴 store에 설정
 */
export const setUserSidebar = async (isLogout: boolean = false) => {
  if (isLogout) {
    userSidebarStore().setRouteYn(false);
    userSidebarStore().setSidebarMenu([]);
    return true;
  }
  // API 호출 (div: 사용자구분)
  const menuList = await getCmmnUserMenuRoutes("student");

  // 메뉴가 없거나 빈 배열이면 실패 처리
  if (!menuList || menuList.length === 0) return false;

  // API 응답에서 첫 루트의 children을 메뉴 트리로 변환
  const sidebarMenu = convertRouterToMenu(menuList[0]?.children ?? []);

  // sotre에 route 등록 여부 및 사이드바 메뉴 저장
  userSidebarStore().setRouteYn(true);
  userSidebarStore().setSidebarMenu(sidebarMenu);

  return true;
};

/**
 * 라우터 데이터를 UI용 메뉴 트리로 변환
 */
const convertRouterToMenu = (routerData: unknown): MenuTreeTypes[] => {
  const data = routerData as MenuTypes[];

  return data.map((route) => {
    const menu = {
      menuName: route.name,
      url: route.url,
      children:
        route.children && route.children.length > 0 ? convertRouterToMenu(route.children) : null,
    } as MenuTreeTypes;

    return menu;
  });
};
